import type {
  ContractResponse,
  ContractSignDeclarations,
  LoanContractResponse,
  LoanContractsHistory,
  LoanContractSummary,
  LoanLimits,
} from '@/features/loan/types/loan';
import { BaseApiService } from '../../../api/base';

class LoanApiService extends BaseApiService {
  public generateContract(
    isRealBeneficiary: boolean
  ): Promise<ContractResponse> {
    return this.post<ContractResponse>(`/loans/contracts/generate`, {
      isRealBeneficiary,
      isPoliticallyExposed: false,
    });
  }

  public downloadContract(contractId: string): Promise<string> {
    return this.get<string>(`/loans/contracts/${contractId}/document-link`);
  }

  public requestContractSignCode(contractId: string): Promise<void> {
    return this.post(`/loans/contracts/${contractId}/send-otp`);
  }

  public signContractWithCode(
    contractId: string,
    code: string,
    declarations: ContractSignDeclarations,
    orderId?: string
  ): Promise<boolean> {
    return this.post<boolean>(`/loans/contracts/${contractId}/confirm-otp`, {
      code,
      orderId,
      ...declarations,
    });
  }

  public getActiveLoanSummary(): Promise<LoanContractSummary | null> {
    return this.get<LoanContractSummary | null>(`/wlc/loans/active-loan`);
  }

  public getLoanContractsHistory(): Promise<LoanContractsHistory[]> {
    return this.get<LoanContractsHistory[]>(`/loans/contracts/history`);
  }

  public getLoanLimits(): Promise<LoanLimits | undefined> {
    return this.get<LoanLimits | undefined>(`/loans/limits`);
  }

  public getCurrentContract(): Promise<LoanContractResponse> {
    return this.get<LoanContractResponse>(`/loans/contracts/current`);
  }
}

export const loanApiService = new LoanApiService();
